/**
 * BNS-3350: the exam question list endpoint requires an exam_id. A missing
 * value must never be sent: once stringified into a query string it becomes
 * `exam_id=undefined` / `null` / `NaN`, which the backend cannot parse.
 */
const MISSING_EXAM_ID_LITERALS = ['', '0', 'undefined', 'null', 'nan'];

export const isValidExamId = (examId) => {
  if (typeof examId === 'number') {
    return Number.isFinite(examId) && examId !== 0;
  }
  if (typeof examId !== 'string') {
    return false;
  }

  return !MISSING_EXAM_ID_LITERALS.includes(examId.trim().toLowerCase());
};
